import { isLocalTenantDevelopmentHost } from '@/utils/tenant.utils'

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '')
}

function ensureApiPath(configuredUrl: string): string {
  try {
    const parsedApiUrl = new URL(configuredUrl)
    const normalizedPath = parsedApiUrl.pathname.replace(/\/+$/, '')

    if (!normalizedPath) {
      parsedApiUrl.pathname = '/api'
      return parsedApiUrl.toString()
    }

    return parsedApiUrl.toString()
  } catch {
    return configuredUrl
  }
}

function getLocalTenantApiHost(configuredUrl: string): string {
  if (typeof window === 'undefined' || !isLocalTenantDevelopmentHost(window.location.hostname)) {
    return configuredUrl
  }

  try {
    const parsedApiUrl = new URL(configuredUrl)

    if (parsedApiUrl.hostname === 'localhost') {
      parsedApiUrl.hostname = window.location.hostname
      return parsedApiUrl.toString()
    }
  } catch {
    return configuredUrl
  }

  return configuredUrl
}

export function getEdunodeApiBaseUrl(): string {
  const configuredUrl =
    process.env.NEXT_PUBLIC_EDUNODE_API_URL ||
    process.env.NEXT_PUBLIC_COMMUNITY_API_URL ||
    'http://localhost:3001/api'

  return trimTrailingSlash(getLocalTenantApiHost(ensureApiPath(configuredUrl)))
}



/**
 * Server-side-only API key for edunode-be.
 * Uses non-NEXT_PUBLIC env vars so the key never appears in the browser bundle.
 * Falls back to the deprecated NEXT_PUBLIC vars during migration.
 */
export function getServerApiKey(): string {
  return (
    process.env.EDUNODE_API_KEY ||
    process.env.EDUNODE_SHARED_API_KEY ||
    process.env.NEXT_PUBLIC_EDUNODE_SHARED_API_KEY ||
    process.env.NEXT_PUBLIC_SHARED_API_KEY ||
    process.env.NEXT_PUBLIC_API_KEY ||
    ''
  )
}

/**
 * Server-side base URL for edunode-be.
 * Does not apply local-tenant hostname rewriting (server runs on localhost).
 */
export function getEdunodeServerBaseUrl(): string {
  const configuredUrl =
    process.env.EDUNODE_API_URL ||
    'http://localhost:3001/api'

  return trimTrailingSlash(ensureApiPath(configuredUrl))
}
